<template>
    <div>
        <div v-if="hasSeenByUser()" :class="['badge text-white', variant]" v-text="status" :title="$t('ticket.status.seenByUser')">
        </div>
        <div v-else :class="['badge text-white', variant]" v-text="status">
        </div>
        <i :class="getClass" class="pl-2" style="font-size: 1.15rem" aria-hidden="true"></i>
    </div>
</template>

<script>
import Vue from 'vue'
import { statusVariant, statusStr, ticketStatus } from '@/constants/ticketStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        status() {
            return statusStr.get(this.row.status)
        },
        variant() {
            return 'badge-'+statusVariant(this.row.status)
        },
        getClass() {
            if (this.row.priority === 0)
                return 'text-success fa fa-chevron-down';
            if (this.row.priority === 1)
                return 'text-warning fa fa-minus';

            return 'text-danger fa fa-chevron-up';
        }
    },
    methods: {
        hasSeenByUser() {
            if (this.row.status === ticketStatus.CLOSED_BY_ADMIN_WHEN_SEEN_BY_USER ||
                this.row.status === ticketStatus.CLOSED_BY_TIME_WHEN_SEEN_BY_USER  ||
                this.row.status === ticketStatus.CLOSED_BY_ADMIN_WHEN_REPLIED_BY_USER)
            {
                return true;
            }

            return false;
        }
    }
})
</script>

<style>

</style>